import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid"
import Button from '@mui/material/Button';

import { yellow } from '@mui/material/colors';
import { getDisplaySize } from "../../utils/Items";
import { Dialog, Typography } from "@mui/material";

// 商品削除ダイアログ
export default function DeleteProductDialog({open, onCloseDialog, productData, deleteProductData}) {

    const nullProductData ={
      
      productName: "",
      origin: "",
      rank: "",
      productClass: "",
      weight: "",
      weightUnit: "",
      orderingUnit: "",
      price: 0    
    }
  
    const {productName, origin, rank, productClass, weight, weightUnit, orderingUnit, basePrice, marketPrice} = productData ? productData : nullProductData;
  
    var basePriceDisplay = "-";

    if (basePrice) {
      basePriceDisplay = basePrice.toLocaleString()
    } 

    const onClickDelete = (event) => {
      deleteProductData();
      alert(
        "以下の商品を削除しました。\n"
        + `商品: ${productName}\n`
        + `産地: ${origin}\n`
        + `発注規格: ${getDisplaySize(rank, productClass, weight, weightUnit)}\n`
        + `発注単位: ${orderingUnit}\n`
        + `基本価格: ${basePriceDisplay}`
        + `\n${marketPrice ? "市況価格: " + marketPrice.toLocaleString() : ""}`
      );
      onCloseDialog(event);
    }
  
    const onCloseCancel = (event) => {
      onCloseDialog(event);
    }
  
    return(
      <Dialog open={open} onClose={onCloseCancel}>
        <Box padding={2} minWidth={400}>
          <Typography fontSize={20} fontWeight={700}>削除</Typography>
          <Box marginTop={2} marginBottom={1}>
            <Typography>基本価格表から、以下の商品を削除します。</Typography>
            <Box backgroundColor={yellow[100]} marginY={1} padding={1}>
              <Typography fontSize={20}>商品:&nbsp;{productName}</Typography>
              <Typography fontSize={20}>産地:&nbsp;{origin}</Typography>
              <Typography fontSize={20}>発注規格:&nbsp;{getDisplaySize(rank, productClass, weight, weightUnit)}</Typography>
              <Typography fontSize={20}>発注単位:&nbsp;{orderingUnit}</Typography>
              <Typography fontSize={20}>基本価格:&nbsp;{basePriceDisplay}</Typography>
              {marketPrice
                ? <Typography fontSize={20}>市況価格:&nbsp;{marketPrice.toLocaleString()}</Typography>
                : null
              }
            </Box>
          </Box>
  
          <Grid container>
            <Grid item xs textAlign='center'>
              <Button
                variant="contained"
                color='error'
                onClick={onClickDelete}
              >
                削除
              </Button>
            </Grid>
            <Grid item xs textAlign='center'>
              <Button variant="outlined" onClick={onCloseCancel}>戻る</Button>
            </Grid>
          </Grid>
        </Box>
      </Dialog>
    )
  }
  